import script from "./App.vue?vue&type=script&lang=tsx"
export * from "./App.vue?vue&type=script&lang=tsx"

import "./App.vue?vue&type=style&index=0&id=7c7bdaca&lang=scss&scoped=true"

import exportComponent from "/builds/dc/siemens.fm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c7bdaca"]])

export default __exports__